import React from 'react';
import {useTranslation} from 'react-i18next';
import {IConversationData} from '../../../model/conversationModel';
import conversationApi from '../../../service/conversationApi';
import {MenuItem} from '@techsmith/tsc-cloud-style-guide';
import withMemoizedContexts from '../../../context/contextContainerHoC';
import {mediaStore} from '../../../context/mediaProvider';

export const ConversationActionMenuBase: React.FC<IConversationActionMenuProps & IStateMappedProps> = ({conversation, setError, setShowClearCommentsModal, Hash}) => {
   const {t} = useTranslation();

   const onDownloadCommentsClick = async () => {
      try {
         await conversationApi.downloadSingleConversationData(Hash, conversation.ConversationHash);
      } catch {
         setError();
      }
   };

   return (
      <>
         <MenuItem
            key="download"
            onClick={onDownloadCommentsClick}
            label={t('conversations.actions.download')}
            testId="DownloadMenuItem"
         />
         <MenuItem
            key="clear-comments"
            onClick={() => setShowClearCommentsModal(true)}
            label={t('conversations.actions.clearComments')}
            testId="ClearCommentsMenuItem"
         />
      </>
   );
};

export interface IConversationActionMenuProps {
   conversation: IConversationData;
   setError: () => void;
   setShowClearCommentsModal: (showModal: boolean) => void;
}

export interface IStateMappedProps {
   Hash: string;
}

const mapStatesToProps = (
   {conversation, setError, setShowClearCommentsModal}: IConversationActionMenuProps,
   {Hash}: Partial<IStateMappedProps>
): IStateMappedProps & IConversationActionMenuProps => ({conversation, setError, setShowClearCommentsModal, Hash});

export default withMemoizedContexts(mapStatesToProps, mediaStore)(ConversationActionMenuBase);
